import { styled } from 'styled-components'

// Define props interface
interface TreeBranchProps {
  before?: boolean
  after?: boolean
  dropInside?: boolean
}

const StyledTreeBranch = styled.div<TreeBranchProps>`
  position: relative;
  margin-left: 0.5rem;
  padding-left: 0.5rem;
  border-left: 1px solid #d1d5db; /* equivalent to border-gray-300 */

  /* Drop target before */
  ${({ before }) =>
    before &&
    `
    &::before {
      content: '';
      position: absolute;
      top: -2px;
      left: 0;
      right: 0;
      height: 2px;
      background-color: #1890ff;
      border-radius: 1px;
      animation: pulse 1.5s infinite;
      z-index: 10;
    }
  `}

  /* Drop target after */
  ${({ after }) =>
    after &&
    `
    &::after {
      content: '';
      position: absolute;
      bottom: -2px;
      left: 0;
      right: 0;
      height: 2px;
      background-color: #1890ff;
      border-radius: 1px;
      animation: pulse 1.5s infinite;
      z-index: 10;
    }
  `}

  /* Drop target inside */
  ${({ dropInside }) =>
    dropInside &&
    `
    background-color: rgba(80, 223, 255, 0.15);
    box-shadow: 0 0 0 1px #50dfff;
  `}

  @keyframes pulse {
    0%,
    100% {
      opacity: 0.7;
    }
    50% {
      opacity: 1;
    }
  }
`
export default StyledTreeBranch
